/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetApOfficeAiSettingResponse } from '../model/getApOfficeAiSettingResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { PostAgreementAiServiceRequest } from '../model/postAgreementAiServiceRequest';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import type { UpdateAiModelTrainingSettingRequest } from '../model/updateAiModelTrainingSettingRequest';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get AI setting for current office
 */
export const useGetApOfficeAiSettingHook = () => {
  const getApOfficeAiSetting = useCustomClient<GetApOfficeAiSettingResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApOfficeAiSetting(
      { url: `/api/js/ap_office_ai_setting`, method: 'GET', signal },
      options
    );
  };
};

export const getGetApOfficeAiSettingQueryKey = () => {
  return [`/api/js/ap_office_ai_setting`] as const;
};

export const useGetApOfficeAiSettingQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApOfficeAiSettingQueryKey();

  const getApOfficeAiSetting = useGetApOfficeAiSettingHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>
  > = ({ signal }) => getApOfficeAiSetting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApOfficeAiSettingQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>
>;
export type GetApOfficeAiSettingQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get AI setting for current office
 */
export const useGetApOfficeAiSetting = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApOfficeAiSettingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApOfficeAiSettingSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApOfficeAiSettingQueryKey();

  const getApOfficeAiSetting = useGetApOfficeAiSettingHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>
  > = ({ signal }) => getApOfficeAiSetting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApOfficeAiSettingSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>
>;
export type GetApOfficeAiSettingSuspenseQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get AI setting for current office
 */
export const useGetApOfficeAiSettingSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetApOfficeAiSettingHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApOfficeAiSettingSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Toggles whether the office allows its input data to be used for
AI model training. Defaults to false (opt-out) until the office
explicitly enables it.

 * @summary Update model training data usage setting for current office
 */
export const useUpdateAiModelTrainingSettingHook = () => {
  const updateAiModelTrainingSetting = useCustomClient<void>();

  return (
    updateAiModelTrainingSettingRequest: BodyType<UpdateAiModelTrainingSettingRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return updateAiModelTrainingSetting(
      {
        url: `/api/js/ai_model_training_setting`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateAiModelTrainingSettingRequest,
      },
      options
    );
  };
};

export const useUpdateAiModelTrainingSettingMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateAiModelTrainingSettingHook>>>,
    TError,
    { data: BodyType<UpdateAiModelTrainingSettingRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateAiModelTrainingSettingHook>>>,
  TError,
  { data: BodyType<UpdateAiModelTrainingSettingRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const updateAiModelTrainingSetting = useUpdateAiModelTrainingSettingHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateAiModelTrainingSettingHook>>>,
    { data: BodyType<UpdateAiModelTrainingSettingRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateAiModelTrainingSetting(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAiModelTrainingSettingMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateAiModelTrainingSettingHook>>>
>;
export type UpdateAiModelTrainingSettingMutationBody =
  BodyType<UpdateAiModelTrainingSettingRequest>;
export type UpdateAiModelTrainingSettingMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Update model training data usage setting for current office
 */
export const useUpdateAiModelTrainingSetting = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateAiModelTrainingSettingHook>>>,
    TError,
    { data: BodyType<UpdateAiModelTrainingSettingRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useUpdateAiModelTrainingSettingMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Submitting means agreeing to the AI service.
 * @summary Agree to the terms of use of the AI service for current office
 */
export const usePostAgreementAiServiceHook = () => {
  const postAgreementAiService = useCustomClient<void>();

  return (
    postAgreementAiServiceRequest: BodyType<PostAgreementAiServiceRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return postAgreementAiService(
      {
        url: `/api/js/agreement_ai_service`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postAgreementAiServiceRequest,
      },
      options
    );
  };
};

export const usePostAgreementAiServiceMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostAgreementAiServiceHook>>>,
    TError,
    { data: BodyType<PostAgreementAiServiceRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePostAgreementAiServiceHook>>>,
  TError,
  { data: BodyType<PostAgreementAiServiceRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const postAgreementAiService = usePostAgreementAiServiceHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePostAgreementAiServiceHook>>>,
    { data: BodyType<PostAgreementAiServiceRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postAgreementAiService(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgreementAiServiceMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePostAgreementAiServiceHook>>>
>;
export type PostAgreementAiServiceMutationBody =
  BodyType<PostAgreementAiServiceRequest>;
export type PostAgreementAiServiceMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Agree to the terms of use of the AI service for current office
 */
export const usePostAgreementAiService = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostAgreementAiServiceHook>>>,
    TError,
    { data: BodyType<PostAgreementAiServiceRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = usePostAgreementAiServiceMutationOptions(options);

  return useMutation(mutationOptions);
};
